module.exports = __webpack_public_path__ + "img/product-11.95347eba.jpg";